import { createLogOnce } from "./createLogOnce.mjs";
export const error = createLogOnce('error', 'Base UI');
export { reset } from "./createLogOnce.mjs";